import { useMemo } from 'react';

import { Gear as GearIcon, Sorting as SortIcon } from '@air/next-icons';
import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';
import { useAirModal } from '@air/provider-modal';

import { GeneralLibrarySettingsModal } from '~/components/LibraryBeta/GeneralLibrarySettingsModal/GeneralLibrarySettingsModal';
import { useSortMenuOptions } from '~/components/LibraryBeta/hooks/useSortMenuOptions';

export const useGeneralLibraryMenuOptions = () => {
  const [showGeneralLibrarySettingsModal] = useAirModal(GeneralLibrarySettingsModal);
  const { sortDropdownMenuOptions } = useSortMenuOptions({ location: 'general library' });

  const menuOptions = useMemo(() => {
    const options: DropdownMenuOption[] = [
      {
        id: 'library-settings',
        label: 'Library settings',
        onSelect: () => showGeneralLibrarySettingsModal(),
        prefix: <GearIcon className="size-4" />,
        type: 'item',
      },
    ];

    if (sortDropdownMenuOptions.length > 0) {
      options.push({
        id: 'sort-boards',
        label: 'Sort boards',
        prefix: <SortIcon className="size-4" />,
        type: 'sub',
        options: sortDropdownMenuOptions,
      });
    }

    return options;
  }, [showGeneralLibrarySettingsModal, sortDropdownMenuOptions]);

  return { menuOptions };
};
